import * as React from "react";
const SvgNavigateUpLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m12.707 7.293 7 7a1 1 0 0 1-1.414 1.414L12 9.415l-6.293 6.292a1 1 0 0 1-1.414-1.414l7-7a1 1 0 0 1 .648-.291h.118c.236.014.468.11.648.29", clipRule: "evenodd" }));
export default SvgNavigateUpLine;
